// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ba305ade","186":"5845c054","272":"84d92d4e","372":"2b49d63e","377":"36033272","738":"ad98c65c","841":"aae5f774","851":"0a74ee48","856":"3437e53b"}[chunkId] + ".chunk.js";
};